<template>
  <SearchPage
    v-slot="{ hit }"
    endpoint="call-for-witnesses"
    :title="entity?.title"
    :filter-titles="{
      organization: $texts('pressReleaseSender', 'Absender'),
    }"
    group-by="group"
    :search-result-titles="{
      singular: $texts('search.callForWitnessesSingular', 'Zeugenaufruf'),
      plural: $texts('search.callForWitnessesPlural', 'Zeugenaufrufe'),
    }"
  >
    <SearchResultPressRelease v-bind="hit" />
  </SearchPage>
</template>

<script lang="ts" setup>
definePageMeta({
  name: 'bs-call-for-witnesses',
  drupalFrontendRoute: true,
  ariaLive: 'off',
  languageMapping: {
    de: '/apps/zeugenaufrufe',
    en: '/en/apps/call-for-witnesses',
    fr: '/fr/apps/appel-a-temoin',
    it: '/it/apps/richiesta-di-testimoni',
  },
})

const { entity } = await useDrupalRouteQuery('page')
await renderPageDependencies()
</script>
